import { parseAccent } from '@brands/shared';
import { accents, colors } from '../styles/tokens';

/** Nombres en español para el selector y los lectores de pantalla. */
export const ACCENT_LABEL: Record<keyof typeof accents, string> = {
  navy: 'Azul marino',
  blue: 'Azul eléctrico',
  deepBlue: 'Azul profundo',
  sky: 'Azul cielo',
  mint: 'Menta',
  green: 'Verde',
  lime: 'Lima',
  yellow: 'Amarillo',
  tangerine: 'Mandarina',
  amber: 'Ámbar',
  orange: 'Naranja',
  coral: 'Coral',
  red: 'Rojo',
  magenta: 'Magenta',
  purple: 'Morado',
  lilac: 'Lila',
  mauve: 'Malva',
  midnight: 'Medianoche',
  black: 'Negro',
};

/** Color de un acento guardado: nombre de la paleta o color propio (#rrggbb). */
export function accentHex(value: string | null | undefined): string {
  const accent = parseAccent(value);
  if (!accent) return accents.navy;
  return accent.startsWith('#') ? accent : accents[accent as keyof typeof accents];
}

/** Luminancia relativa (WCAG) de un color #rrggbb. */
function luminance(hex: string): number {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** Texto legible sobre el acento: negro sobre colores claros, blanco sobre oscuros. */
export function onAccent(value: string | null | undefined): string {
  // 0.3: texto oscuro en amarillo, lima, menta, lila, cielo, ámbar y mandarina; blanco en naranja y
  // rojo, como en brands.mx.
  return luminance(accentHex(value)) > 0.3 ? colors.ink : colors.bg;
}

/**
 * Colores de una marca: el principal y el secundario (elegido o calculado). Sin secundario, se usa
 * negro sobre principales claros y amarillo de brands.mx sobre oscuros.
 */
export function brandColors(accent: string | null | undefined, accent2?: string | null) {
  const primary = accentHex(accent);
  const secondary = parseAccent(accent2)
    ? accentHex(accent2)
    : luminance(primary) > 0.3
      ? colors.inkSoft
      : accents.yellow;
  return {
    primary,
    secondary,
    onPrimary: onAccent(primary),
    onSecondary: onAccent(secondary),
  };
}
